// extracted by mini-css-extract-plugin
export default {"container":"TidbitsCard_container__uG-In","header":"TidbitsCard_header__6gnlf","body":"TidbitsCard_body__3EEMx"};